import React from "react";
import { SourceLibraryEvidencePanels } from "../components/SourceLibraryPanels.jsx";

export function SourceLibrary() {
  return <SourceLibraryEvidencePanels />;
}
